module.exports = __webpack_public_path__ + "img/p1.87d5c4b2.png";